const API = process.env.REACT_APP_BACKEND_URL;

export const ExecApproval = ({ r, onDone }) => {
  const act = async (what) => {
    const q = what === "approve" ? `Confirm you called ${r.name} and approve them for dispatch?` : `Revoke ${r.name}? They will not receive work orders.`;
    if (!window.confirm(q)) return;
    await fetch(`${API}/api/admin/trade-network/roster/${r.partner_id}/${what}`, { method: "POST", credentials: "include" });
    onDone && onDone();
  };
  return (
    <div className="rr-offer" data-testid={`roster-exec-${r.partner_id}`}>
      <span className={`rr-tag ${r.tier === "independent" ? "rr-tag--invited" : "rr-tag--active"}`} data-testid={`roster-tier-${r.partner_id}`}>{r.tier === "independent" ? "Independent · low-risk only" : "Commercial insured"}</span>
      {r.exec_approved
        ? <button type="button" onClick={() => act("revoke")} data-testid={`roster-revoke-${r.partner_id}`}>Revoke</button>
        : <button type="button" onClick={() => act("approve")} data-testid={`roster-approve-${r.partner_id}`}>Called · approve</button>}
      {!r.work_ready && r.missing?.length > 0 && <span className="rr-muted" data-testid={`roster-missing-${r.partner_id}`}>Needs: {r.missing.join("; ")}</span>}
    </div>
  );
};
